import { render } from "./UploadPosterPage.vue?vue&type=template&id=b194be3c&scoped=true&ts=true"
import script from "./UploadPosterPage.vue?vue&type=script&lang=ts"
export * from "./UploadPosterPage.vue?vue&type=script&lang=ts"

import "./UploadPosterPage.vue?vue&type=style&index=0&id=b194be3c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/democratielab-poster/democratielab-poster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b194be3c"]])

export default __exports__